export default "__VITE_ASSET__DEE2orwh__"